// What the watch and annotate pages open with: the French series
// "Presque adultes" as a YouTube playlist, so the player can step through
// every episode.
export const DEFAULT_MEDIA_URL =
  'https://www.youtube.com/playlist?list=PL_LlpRn0Ot0Y22wi8ow7P0yIMga4B3dxt';
